import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import Container from '@material-ui/core/Container';
import {
    useStylesBt,
} from '../../../../../St/comps/UseStyle';
import axios from 'axios';
import toast from 'react-hot-toast';
import { insh } from '../../../../../Context/InshSt';
import { uri } from '../../../../../help/Api';
import DeleteConfirmDialog from '../../../../../components/DeleteConfirmDialog';
import { sto } from '../../../../../Context/InshData';
export default function OutstandingInvoiceTable(props) {

    const {
        data,
        showChosedInvt,
        viewHandle
    } = props;

    const clasBt = useStylesBt();
    const [menPostion, setMenuPostion] = useState(null);

    const handleClickOutLine = () => {
        setMenuPostion(null);
    };
    const handleClickInLine = (e, item) => {
        e.preventDefault();
        setMenuPostion({
            x: e.pageX,
            y: e.pageY,
            item: item,
        });
    };

    const menuBottons = (item) => {
        return (
            <ul
                style={{
                    position: "absolute",
                    top: menPostion.y,
                    left: menPostion.x,
                    background: "white",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    listStyle: "none",
                    padding: "5px 0",
                    boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
                    width: "150px"
                }}
            >
                <li
                    style={{
                        padding: "8px 12px",
                        cursor: "pointer",
                        borderBottom: "1px solid #eee"
                    }}
                    onClick={(e) => {
                        setConfirmDialog({
                            isOpen: true,
                            onConfirm: () => {
                                onDeleteHandle(e, menPostion.item, menPostion?.item?.branch, 0);
                            },
                        })
                    }}
                >
                    {"حذف الفاتورة المعلقة"}
                </li>
                <li
                    style={{
                        padding: "8px 12px",
                        cursor: "pointer",
                        borderBottom: "1px solid #eee"
                    }}
                    onClick={(e) => {
                        setConfirmDialog({
                            isOpen: true,
                            onConfirm: () => {
                                onDeleteHandle(e, menPostion.item, sto.branchi, 1);
                            },
                        })
                    }}
                >
                    {"حذف جميع الفواتير المعلقة"}
                </li>
            </ul>
        );
    };
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });

    const ButtonLoading = (prop) => {
        setLoading({ ...loading, [prop]: true });
    };
    const timer = React.useRef();

    const ButtonSuccess = (prop, timr) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            viewHandle();
        }, timr);
    };

    const onDeleteHandle = async (e, row, branch, type) => {
        await e.preventDefault();
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
            Urls = `InvDate?proc_id=${row.proc_id}&&branch=${branch}&&type=${type}`
        } else {
            Urls = `InvDate?proc_id=${row.proc_id}&&branch=${branch}&&type=${type}&&db_name=${sto?.db_name}`
        }
        ButtonLoading("delete");
        await axios.delete(uri + Urls).then(res => {
            if (parseFloat(res?.data) > 0) {
                toast.success("لقد تم الحذف  بنجاح");
                ButtonSuccess("delete", true);
            }

        }).catch(err => {
            console.log("eror", err)
            ButtonSuccess("delete", false);
            toast.error("not delete ")
        })
    };

    return (
        <div
            style={{ minWidth: "100vw" }}
            onClick={(e) => handleClickOutLine(e)}
        >
            <React.Fragment>

                <Container>
                    <Grid itemblg={12} md={12} sm={12} xs={12} container className={clasBt.root} style={{ marginTop: 30 }}>
                        {data.map(item => (
                            <Grid lg={2} md={3} sm={4} xs={6} item>
                                <Chip label={item.tot_net} color="gray" className={clasBt.ChipM} clickable
                                    onClick={() => showChosedInvt(true, item.proc_id)}
                                    onContextMenu={(e) => handleClickInLine(e, item)} />
                            </Grid>

                        ))

                        }
                    </Grid>
                    {menPostion && menuBottons()}

                    <DeleteConfirmDialog
                        confirmDialog={confirmDialog}
                        setConfirmDialog={setConfirmDialog}
                    />
                </Container>
            </React.Fragment>
        </div>
    )
}